'use strict';

function InteractiveCreditScoreDial() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [_ResponsiveLayout];

  // props
  this.hasHoverControls = true;
  this.hasClickControls = false;
  this._isHover = false;
  this._isClicked = false;
  this._score = null;
  this.fxDuration = 700;
  this.initScore = 350;
  this._timeout = null;
  this._hasRunScoreAnimate = false;
  this.onShowSection = null;

  // list of score ranges their rotation
  // degree start and end point and the class selector
  this._scoreRanges = [{
    selector: '1',
    degree: [-183, -40],
    score: [300, 559]
  }, {
    selector: '2',
    degree: [-37, 4],
    score: [560, 659]
  }, {
    selector: '3',
    degree: [8, 33],
    score: [660, 724]
  }, {
    selector: '4',
    degree: [37, 48],
    score: [725, 759]
  }, {
    selector: '5',
    degree: [52, 87],
    score: [760, 849]
  }, {
    selector: '6',
    degree: [92, 124],
    score: [850, 900]
  }];

  this._wigScore = null;

  this.init = function () {};
  this.initAllReady = function () {
    this.$node = $(this.node);
    this.$node.addClass('show');

    this.updateCreditScoreDial(this.score);
    this._setComputedVariables();

    // when the user resizes reset the dial
    if (this.hasHoverControls) $(window).resize(this._offHover.bind(this));

    // bind window resize to update layout fix [#151924950]
    this.registerResponsiveFunction(this.fixLayout.bind(this), null, null);
  };

  this.fixLayout = function () {
    // wiggle the dial a bit to fix it (remember when you had to kick your tv?)
    var _initialScore = parseInt(this._score);
    if (_initialScore > 300 && _initialScore < 900) {
      this._wigScore = this._wigScore < _initialScore ? _initialScore + 1 : _initialScore - 1;
      this._setScoreDial(this._wigScore);
    }
  };

  this._setComputedVariables = function () {
    // Setup computed variables
    // Current year for empty credit state
    this.presenter.addComputedVariable('credit_score_year', ['account.credit_check_completed_at'], function () {
      return new Date().getFullYear();
    });

    // Current month truncated for empty credit score
    this.presenter.addComputedVariable('credit_score_month', ['account.credit_check_completed_at'], function () {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months[new Date().getMonth()];
    });
  };

  // public init function
  this.updateCreditScoreDial = function (score) {
    this._setStateScore(score);
    if (this.hasHoverControls) this._hoverControls();
    if (this.hasClickControls) this._clickControls();
  };

  // sets the starting point for the dial before
  // it animates to the setStateScore
  this._setDefaultScorePosition = function (score) {
    this._setScoreDial(score);
  };

  // set the dial to the users credit score
  this._setStateScore = function (score) {
    // if score is null then set to empty and exit
    if (score === null || typeof score === 'undefined' || score.length < 1) {
      return this._setStateEmpty();
    }
    // set the score
    this.$node.addClass('hasCreditScore');
    this.$node.removeClass('hasNoCreditScore');
    this._animateScore(score);
    this._setScoreDial(score);
    this._score = score;
  };

  // set the state to a null state
  this._setStateEmpty = function () {
    this.$node.removeClass('hasCreditScore');
    this.$node.addClass('hasNoCreditScore');

    // rotate point deg to fix browser bug
    // from css rotate not using transform-origin on load
    this._setScoreDial(this.initScore);
  };

  // set to hover/clicked filled state
  this._setStateFilled = function (rangeId) {
    this.$node.addClass('isSelected');
    var midRangeScore = this._scoreRanges[rangeId].score[1] - (this._scoreRanges[rangeId].score[1] - this._scoreRanges[rangeId].score[0]) / 2;
    this._setScoreDial(midRangeScore + 1); // HACK: plus 1 helps center /shrug
  };

  // set state back to a score state remove filled state
  this._removeStateFilled = function () {
    this.$node.removeClass('isSelected');
    this._setStateScore(this._score);
  };

  // animate Credit Score number
  this._animateScore = function (endValue) {
    if (!this._hasRunScoreAnimate) {
      this._hasRunScoreAnimate = true;
      var animatedElement = this.$node.find('.js--credit-score');
      var startingValue = endValue - 200;

      if (startingValue < 300) startingValue = 300;

      $({ value: startingValue }).animate({ value: endValue }, {
        duration: this.fxDuration,
        easing: 'easeInExpo',
        step: function step() {
          animatedElement.text(Math.ceil(this.value));
        },
        complete: function complete() {
          animatedElement.text(Math.ceil(endValue));
        }
      });
    }
  };

  // Diretly update the dial
  this._setScoreDial = function (score) {
    var range = this._getRange(score);
    var rotation = this._calculateScoreRotation(score, range);
    var $rotationGroup = this.$node.find('.interactive-credit-score-dial__rotation-group');

    $rotationGroup.css({
      transform: 'rotate(' + rotation + 'deg)'
    });

    // HACK: IE11 fix to not supporting css transform rotation.
    var startvalue = rotation - 100;
    if (startvalue < -200) startvalue = -200;
    if ($rotationGroup.attr('transform') !== undefined) {
      startvalue = $rotationGroup.attr('transform').split('rotate(')[1].split(' ')[0];
    }

    $({ value: startvalue }).animate({ value: rotation }, {
      duration: this.fxDuration,
      step: function step() {
        $rotationGroup.attr('transform', 'rotate(' + Math.ceil(this.value) + ' 250 250)');
      }
    });
  };

  // return the range data for whatever range the score falls into
  this._getRange = function (score) {
    for (var i = 0; i < this._scoreRanges.length; i++) {
      if (score >= this._scoreRanges[i].score[0] && score <= this._scoreRanges[i].score[1]) {
        return this._scoreRanges[i];
      }
    }
  };

  // calculate rotation degree of score within range (basic linear tween calculation)
  this._calculateScoreRotation = function (score, range) {
    return (range.degree[1] - range.degree[0]) * (score - range.score[0]) / (range.score[1] - range.score[0]) + range.degree[0];
  };

  this._hoverControls = function () {
    var $controls = this.$node.find('.js--interactive-credit-score-dial__control');
    $controls.hover(this._onHover.bind(this), this._offHover.bind(this));
  };

  this._clickControls = function () {
    var $controls = this.$node.find('.js--interactive-credit-score-dial__control');
    $controls.click(this._onClick.bind(this));
  };

  // the user hovers over a section
  this._onHover = function (event) {
    this._isHover = true;
    this.showSection(event.target);

    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      clearTimeout(this._timeout);
      this._timeout = setTimeout(this._offHover.bind(this), 3200);
    }
  };

  // the user ends hover but didnt click
  this._offHover = function () {
    this._isHover = false;
    this.$node.removeAttr('data-selected-id');
    this._removeStateFilled();
  };

  // the user clicks a section
  this._onClick = function (event) {
    this._isHover = true;
    this.showSection(event.target);
  };

  // Ex: $(".js--interactive-credit-score-dial").mogo().showSection("#interactive-credit-score-dial__section-3-control");
  this.showSection = function (element) {
    var _selectedId = $(element).attr('data-section-id');
    this.$node.attr('data-selected-id', _selectedId);
    this._setStateFilled(_selectedId - 1);

    if (this.onShowSection) this.onShowSection(_selectedId - 1);
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('credit_score_year');
    this.presenter.removeComputedVariable('credit_score_month');
  };
}